import { useEffect, useRef } from 'react';
import { toast } from './ui/Toast/Toast';

const THROTTLE_MS = 15000;

/**
 * Escuta o evento 'api-cache-fallback' disparado pelo ApiService quando o
 * backend está inacessível e uma tela precisou usar dados em cache local
 * (ver services/api.ts). Uma tela como o Dashboard dispara várias chamadas
 * GET em paralelo, então isso é throttled para não empilhar vários toasts
 * idênticos durante a mesma queda.
 */
export function ApiCacheFallbackNotice() {
    const lastShownAt = useRef(0);

    useEffect(() => {
        const handler = () => {
            const now = Date.now();
            if (now - lastShownAt.current < THROTTLE_MS) return;
            lastShownAt.current = now;
            toast('Sem conexão com o servidor. Mostrando os últimos dados salvos.', 'info');
        };
        window.addEventListener('api-cache-fallback', handler);
        return () => window.removeEventListener('api-cache-fallback', handler);
    }, []);

    return null;
}
